export default __webpack_public_path__ + "static/media/settingIcons.32967395.svg";